/**
 * Help - Represents help/tooltip information with tips and links.
 * Used to provide contextual help and documentation links throughout the application.
 */
export class Help {
  /** Help tip or tooltip text */
  Tip: string;

  /** Link to additional help documentation */
  Link: string;

  /**
   * Creates a new Help instance
   * @param data - Object containing help properties
   */
  constructor(data: {
    Tip: string;
    Link: string;
  }) {
    this.Tip = data.Tip;
    this.Link = data.Link;
  }

  /**
   * Creates a Help from a plain object (useful for deserialization)
   * @param obj - Plain object with help data
   * @returns New Help instance
   */
  static fromObject(obj: Partial<Help>): Help {
    return new Help({
      Tip: obj.Tip ?? "",
      Link: obj.Link ?? "",
    });
  }

  /**
   * Converts the Help to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      Tip: this.Tip,
      Link: this.Link,
    };
  }
}


